import { useAccessLevelContext } from '../components/Contexts/AccessLevelContext';

export type PageStates = {
  projectEntitlementsError: HttpError;
  results: unknown[];
  search?: string;
};

export const usePageStates = ({
  projectEntitlementsError,
  results,
  search,
}: PageStates) => {
  const {
    accountsWithProjectCreation,
    accountsUserIsAccAccountAdmin,
    accountsUserIsExecutive,
    accountsError,
    accountsLoading,
  } = useAccessLevelContext();

  const canCreateProject = accountsWithProjectCreation?.length > 0;
  const notAuthorized =
    typeof projectEntitlementsError === 'object'
      ? projectEntitlementsError?.status === 401
      : false;
  const showLoadingState =
    (!results && !projectEntitlementsError) || notAuthorized;
  const showEmptyState =
    !notAuthorized && search?.trim() === '' && results?.length === 0;
  const showErrorState =
    (!showLoadingState && projectEntitlementsError) ||
    (accountsError && !accountsLoading);

  return {
    canCreateProject,
    notAuthorized,
    showLoadingState,
    showEmptyState,
    showErrorState,
    accountsUserIsAccAccountAdmin,
    accountsUserIsExecutive,
  };
};
